// extracted by mini-css-extract-plugin
export var headerContentContainer = "sparkLocation-module--headerContentContainer--1WHI2";
export var backgroundImageWrapper = "sparkLocation-module--backgroundImageWrapper--lVYi9";
export var headingContentWrapper = "sparkLocation-module--headingContentWrapper--127BR";
export var headingContent = "sparkLocation-module--headingContent--23Wag";
export var pageTitle = "sparkLocation-module--pageTitle--2Gi7l";
export var pageSubHeader = "sparkLocation-module--pageSubHeader--2alJs";
export var registerButtonStyles = "sparkLocation-module--registerButtonStyles--2HAku";
export var bookButtonStyles = "sparkLocation-module--bookButtonStyles--1y_mP";
export var locationDetailsContentContainer = "sparkLocation-module--locationDetailsContentContainer--3yGAR";
export var bookButtonStylesMobile = "sparkLocation-module--bookButtonStylesMobile--qYe2P";
export var divisionOne = "sparkLocation-module--divisionOne--1_QuG";
export var locationName = "sparkLocation-module--locationName--10Qse";
export var paymentRate = "sparkLocation-module--paymentRate--1aszo";
export var Address = "sparkLocation-module--Address--1tDfd";
export var discountText = "sparkLocation-module--discountText--1K96D";
export var venue = "sparkLocation-module--venue--7uwCw";
export var divisionTwo = "sparkLocation-module--divisionTwo--1pNmE";
export var IllustrationImg = "sparkLocation-module--IllustrationImg--3Leh9";
export var OtherLocationsContentContainer = "sparkLocation-module--OtherLocationsContentContainer--2XYBS";
export var locationCardContainer = "sparkLocation-module--locationCardContainer--fZnoH";
export var pin = "sparkLocation-module--pin--17v80";